/**
 * Retorno a la lista de origen (docs/redesign/accounting/03 NAV-04): cuando una tarea
 * de Pendientes abre su origen (Bancos, Diario), la URL lleva `?return=<ruta>` para
 * poder volver exactamente a la misma lista, con sus filtros.
 *
 * `return` viaja en la URL, así que es ENTRADA NO CONFIABLE: solo se acepta una ruta
 * interna de Contabilidad. Nada de esquemas, hosts, `//`, barras invertidas, `..` ni
 * caracteres de control (open-redirect).
 */
export const RETURN_PARAM = 'return';

const MAX_LENGTH = 300;

/** Ruta interna de Contabilidad válida, o `null`. */
export function safeReturnPath(raw) {
  if (typeof raw !== 'string' || raw.length === 0 || raw.length > MAX_LENGTH) return null;
  if (!/^\/accounting(\/|\?|$)/.test(raw)) return null;
  if (raw.includes('//') || raw.includes('\\') || raw.includes('..') || raw.includes('#')) return null;
  if ([...raw].some((c) => c.charCodeAt(0) < 32 || c.charCodeAt(0) === 127)) return null;

  // El PATH se valida con lista blanca estricta: solo letras, dígitos, `-`, `_` y `~`. Sin
  // `%` (un `%2e%2e` que el navegador normalizaría como dot-segment al seguir el enlace),
  // sin `.` (ninguna ruta de Contabilidad lo lleva) y sin segmentos vacíos. La QUERY no
  // se interpreta como ruta, así que puede llevar `%` (los ids de tarea van codificados).
  const path = raw.split('?')[0].replace(/\/$/, '');
  const segments = path.split('/').slice(1);
  if (!segments.every((segment) => /^[A-Za-z0-9_~-]+$/.test(segment))) return null;
  return raw;
}

/** Añade `return=<from>` a `url` si `from` es una ruta válida; si no, devuelve `url` intacta. */
export function withReturn(url, from) {
  const safe = safeReturnPath(from);
  if (!url || !safe) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}${RETURN_PARAM}=${encodeURIComponent(safe)}`;
}
